export default "__VITE_ASSET__B8MPOv3s__"